import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <img 
              src={companyInfo.logo} 
              alt="Sağlık Tur" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-slate-400 leading-relaxed">
              {companyInfo.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Hızlı Linkler</h4>
            <nav className="flex flex-col space-y-3">
              <a href="#anasayfa" className="text-slate-400 hover:text-blue-400 transition-colors">
                Ana Sayfa
              </a>
              <a href="#hizmetler" className="text-slate-400 hover:text-blue-400 transition-colors">
                Hizmetlerimiz
              </a>
              <a href="#hakkimizda" className="text-slate-400 hover:text-blue-400 transition-colors">
                Hakkımızda
              </a>
              <a href="#iletisim" className="text-slate-400 hover:text-blue-400 transition-colors">
                İletişim
              </a>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">İletişim</h4>
            <div className="space-y-3">
              <a 
                href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                className="flex items-center gap-3 text-slate-400 hover:text-blue-400 transition-colors"
              >
                <Phone size={18} />
                <span>{companyInfo.phone}</span>
              </a>
              <a 
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-3 text-slate-400 hover:text-blue-400 transition-colors"
              >
                <Mail size={18} />
                <span>{companyInfo.email}</span>
              </a>
              <div className="flex items-center gap-3 text-slate-400">
                <MapPin size={18} />
                <span>{companyInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm">
              &copy; {currentYear} {companyInfo.name}. Tüm hakları saklıdır.
            </p>
            <p className="text-slate-600 text-xs">
              Tasarım: <span className="text-slate-500">Pastel Medya</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
